import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import Widget, { Props } from "../Widget";
import moment from "moment";

const PollWidgetEmbed = (props: Props & { widgetId: string }) => {
  const pollId = React.useRef<string | null>(
    (props.data.pollId as any) || null,
  );

  const [widgetData, setWidgetData] = React.useState<Record<string, unknown>>(
    props.data,
  );

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  useTopic(`user:widgets:${props.type}:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  useTopic(`user:polls:${props.userId}`, (message) => {
    switch (message.event) {
      case "poll:opened":
        const openedPayload = message.payload as Record<string, unknown>;
        pollId.current = openedPayload.pollId as any;
        setWidgetData(openedPayload);
        break;
      case "poll:closed":
        const closedPayload = message.payload as Record<string, unknown>;

        if (closedPayload.pollId === pollId.current) {
          setWidgetData((current) => ({
            ...current,
            endsAt: moment().subtract(1, "seconds").toISOString(),
          }));
        }

        setTimeout(() => {
          if (closedPayload.pollId === pollId.current) {
            pollId.current = null;
            setWidgetData({});
          }
        }, 10_000);

        break;
      case "poll:voted":
        const votePayload = message.payload as Record<string, unknown>;

        if (votePayload.pollId === pollId.current) {
          const option = votePayload.option as string;
          const value = votePayload.value as number;

          setWidgetData((prevData) => ({
            ...prevData,
            votes: {
              ...(prevData.votes as any),
              [option]: ((prevData.votes as any)?.[option] || 0) + value,
            },
          }));
        }

        break;
    }
  });

  if (!pollId.current) {
    return null;
  }

  return <Widget visible={true} {...props} data={widgetData} />;
};

export default PollWidgetEmbed;
